// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonTop_wrapper__I1c4a","top-btn":"ButtonTop_top-btn__O7ixR","top-btn--icon":"ButtonTop_top-btn--icon__xy0e+","gototop":"ButtonTop_gototop__s4lyk"};